window.$ = window.jQuery = require('jquery');

// LazyLoad - https://github.com/aFarkas/lazysizes
import 'lazysizes'
// import a plugin
import 'lazysizes/plugins/parent-fit/ls.parent-fit'

// Theme Functions
const fSmoothScroll = require('./utils/smooth-scroll')
const fCarousels = require('./components/carousels')
const fGSAPController = require('./components/gsap-controller')
const fRolloverTexts = require('./components/rollover-texts')
const fRolloverHeading = require('./components/rollover-heading')
const faccordion = require('./components/accordion')
const fboxCarouselHover = require('./components/box-carousel-hover')
const fVideos = require('./components/videos')
const fBtnEvent = require('./components/btn-event-back')

// Vue Support Function
import {
    createApp,
    defineAsyncComponent
} from 'vue'
import { createStore } from 'vuex'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vuex from 'vuex'

import Datepicker from '@vuepic/vue-datepicker';

// import MainMenu from './vue/main-menu.vue'
// import TimeWeather from './vue/time-weather.vue'
import Events from './vue/events.vue'
import EventsLatest from './vue/events-latest.vue'
import EventsLatestHome from './vue/events-latest-home.vue'
import EventsMonth from './vue/events-month.vue'
// import Mailchimp from './vue/partials/mailchimp.vue'
import Changemakers from './vue/changemakers.vue'
import Plan from './vue/plan.vue'
import MapPoints from './vue/map-points.vue'
import VueGoogleMaps from '@fawmi/vue-google-maps'
import News from './vue/News.vue'

import './utils/jquery.session';

let store = null;

const fullImage = () => {
    const images = document.querySelectorAll(".fullImage");
    const screen = window.innerWidth;

    images.forEach(image => {
        const width = image.getBoundingClientRect().width,
            right = image.getBoundingClientRect().right;

        image.style.width = (screen - right) + width + "px";
    });
}

const InitVueComponents = () => {
    // Async components
    // const TimeWeather = defineAsyncComponent(() => import("./vue/time-weather"));
    const TimeWeather = defineAsyncComponent({
        loader: () => import("./vue/time-weather"),
        // loadingComponent: LoadingComponent /* shows while loading */,
        // errorComponent: ErrorComponent /* shows if there's an error */,
        // delay: 10000 /* delay in ms before showing loading component */,
        // timeout: 30000 /* timeout after this many ms */,
    });
    // const MainMenu = defineAsyncComponent(() => import("./vue/main-menu"));
    const MainMenu = defineAsyncComponent({
        loader: () => import("./vue/main-menu"),
        // loadingComponent: LoadingComponent /* shows while loading */,
        // errorComponent: ErrorComponent /* shows if there's an error */,
        // delay: 10000 /* delay in ms before showing loading component */,
        // timeout: 30000 /* timeout after this many ms */,
    });
    const Mailchimp = defineAsyncComponent({
        loader: () => import("./vue/partials/mailchimp"),
        loadingComponent: MainMenu /* shows while loading */,
        // errorComponent: ErrorComponent /* shows if there's an error */,
        delay: 3000 /* delay in ms before showing loading component */,
        timeout: 3000 /* timeout after this many ms */,
    });
    // Static Components
    // const StaticComponent = require('./vue/multi-file-component/child-component').default;

    store = createStore({
        state () {
            return {
                showMenu: false,
                weatherAndTime: false,
                weather: false,
                time: false,
                open: false
            }
        },
        mutations: {
        }
    })

    // Init Vue Instance
    const $VueApp = createApp({
        store: store,
        watch: {
            '$store.state.showMenu': function() {
                fullImage();
            }
        }
    });

    const $VueFooter = createApp({
        store: store,
        watch: {
            '$store.state.showMenu': function() {
                fullImage();
            }
        }
    });

    // component() can be chained :)

    $VueApp
        .component('MainMenu', MainMenu)
        .component('TimeWeather', TimeWeather)
        .component('Datepicker', Datepicker)
        .component('Events', Events)
        .component('EventsLatest', EventsLatest)
        .component('EventsLatestHome', EventsLatestHome)
        .component('EventsMonth', EventsMonth)
        .component('Mailchimp', Mailchimp)
        .component('Changemakers', Changemakers)
        .component('Plan', Plan)
        .component('MapPoints', MapPoints)
        .component('News', News)
        .use(VueGoogleMaps, {
            load: {
                key: 'AIzaSyAFZido7mzwyEkeW3uk05M3_nb-A4vdS3c',
            },
        })
        .use(VueAxios, axios)
        .use(store)
    $VueApp.mount('#vue-space');
    
    // Footer vue
    $VueFooter
        .component('Mailchimp', Mailchimp)
    $VueFooter.mount('#vue-footer');
}

if ( jQuery.session.get('intro') === 'showed' && document.querySelector('.home-intro-main') ) {
    document.body.classList.remove('relative', 'overflow-hidden')
    document.querySelector('.home-intro-desktop').style.display = 'none';
} else if ( document.querySelector('.home-intro-main') && window.innerWidth <= 768 ) {
    document.body.classList.remove('relative', 'overflow-hidden')
}

// Initialise our components on jQuery.ready…
let startScroll = true;
jQuery(function ($) {
    // Static Functions
    
    InitVueComponents()

    // Async Functions
    fSmoothScroll.init()
    
    fGSAPController.init()
    fRolloverTexts.init()
    fRolloverHeading.init()
    faccordion.init()
    fboxCarouselHover.init()
    fVideos.init();
    fBtnEvent.init();

    $(window).scroll(function() {
        if ($(window).scrollTop() > 0 && startScroll) {
            fCarousels.init()
        }

        startScroll = false;
    });

    // form popup
    if ( document.querySelector('.form-popup') ) {
        const GetInTouch = document.querySelector('.form-popup');
        const btnTextGetInTouch = document.querySelectorAll('a[href*="#get-in-touch"]');
        const btnGetInTouch = document.querySelectorAll('.btn-get-in-touch');
        const btnGetInTouchClose = document.querySelectorAll('.form-popup__close');
    
        btnGetInTouchClose.forEach(item => {
            item.addEventListener('click', event => {
                GetInTouch.style.animation = "closePopup .5s ease";

                window.setTimeout(() => {
                    GetInTouch.classList.add('hidden');
                    GetInTouch.classList.remove('flex');
                    GetInTouch.style.animation = "";
                    document.body.classList.remove('overflow-hidden');
                }, 500);
            });
        })
    
        if ( btnGetInTouch ) {
            btnGetInTouch.forEach(item => {
                item.addEventListener('click', event => {
                    GetInTouch.classList.remove('hidden');
                    GetInTouch.classList.add('flex');
                    document.body.classList.add('overflow-hidden');
                });
            })
        }

        if ( btnTextGetInTouch ) {
            btnTextGetInTouch.forEach(item => {
                item.addEventListener('click', event => {
                    GetInTouch.classList.remove('hidden');
                    GetInTouch.classList.add('flex');
                    document.body.classList.add('overflow-hidden');
                });
            })
        }
    }
})

// $( window ).on("load", function() {});

// viewport height fix
const heightFix = () => {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}

heightFix();


fullImage();

// document.addEventListener('DOMContentLoaded', function() {
//     setTimeout(() => {
//         fullImage();
//     }, 1000);
// }, false);

window.addEventListener('resize', () => {
    heightFix();
    fullImage();
});